var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeveloperToolIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.48 24.6143V55.6543L48.64 57.8687L40.9472 53.4271L33.28 57.8687L21.76 51.2767V49.7407L28.16 46.0415L12.8 37.1712V6.13115L16.64 3.91675L52.48 24.6143Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3601 10.569L46.0801 28.3047V53.4311L15.3601 35.6954V10.569Z",
    fill: "#61FF7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 6.13505L16.64 3.91809L52.48 24.6093L48.64 26.8275L12.8 6.13505Z",
    fill: "#A8A8A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6399 26.8275V57.8649L52.4799 55.648V24.6093L48.6399 26.8275Z",
    fill: "#737373"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.76 49.7356L28.16 46.0415L39.68 52.6924L33.28 56.3877L21.76 49.7356Z",
    fill: "#999999"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.76 49.7356V51.2729L33.28 57.8649V56.3878L21.76 49.7356Z",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.68 52.6924L40.96 53.4309L33.28 57.8649V56.3877L39.68 52.6924Z",
    fill: "#737373"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1599 46.0415V50.4754L31.9999 52.6924V48.2585L28.1599 46.0415Z",
    fill: "#BABABA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52.6925L35.84 50.4755L32 48.2585V52.6925Z",
    fill: "#737373"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3601 35.6954L16.6401 34.9556L46.0801 51.9527V53.4311L15.3601 35.6954Z",
    fill: "#A8A8A8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3601 35.6954V10.569L16.6401 11.3075V34.9555L15.3601 35.6954Z",
    fill: "#737373"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1599 32.7385L24.3199 26.0876L22.3999 27.1961L28.1599 37.1724L40.3199 30.1529L38.3999 26.8275L28.1599 32.7385Z",
    fill: "#268334"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloperToolIcon);
export default __webpack_public_path__ + "static/media/developer-tool-icon.c00f4905b2063b6bf4fbfecb865efcff.svg";
export { ForwardRef as ReactComponent };